import {
  HTTP_GETAPPROVE_FETCHING,
  HTTP_GETAPPROVE_SUCCESS,
  HTTP_GETAPPROVE_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETAPPROVE_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETAPPROVE_SUCCESS:
      return {
        ...state,
        result: payload.data,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETAPPROVE_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
